import * as React from 'react';
import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';
import Typography from '@mui/material/Typography';

export const StyledTextField = styled(TextField)(({ theme }) => ({
    '& .MuiInputBase-input': {
        zIndex: 100,
        display: 'flex',
        justifyContent: 'center',
        fontSize: '16px',
        width: '390px'
    },
    '& .MuiInputLabel-root': {
        backgroundColor: 'white',
        padding: 0,
        margin: 0
    },
    '& .MuiOutlinedInput-root fieldset span': {
        backgroundColor: 'transparent'
    }
}));

export const StyledTextfieldLabel = styled(Typography)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    fontSize: '16px',
    fontWeight: '400'
}));
